import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type HubspotObjectLinkingRow = {
  id: string;
  crm_object_type: string;
  association_type_id: number;
  association_label: string;
  attribution_name: string;
  enabled: boolean;
  position: number;
};

// GET /api/settings/integrations/hubspot — vendor-facing linking table.
export function useHubspotIntegration() {
  return useQuery<HubspotObjectLinkingRow[], ApiClientError>({
    queryKey: queryKeys.settings.integrations(),
    queryFn: () => apiFetch<HubspotObjectLinkingRow[]>("/settings/integrations/hubspot"),
  });
}
